import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getIntroduction (textSize) {
  apiConsolelog('api: getIntroduction(): textSize = %s', textSize)

  return request({
    url: '/intro/show',
    method: 'get',
    text_size: textSize
  })
}
